
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './LogOrRegPagePop.module.css';
import pageStylePops from './pageStylePops.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import {
    theMenuItems
} from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import PopUpClearComp from './PopUpClearComp';
import ConnectPop from './ConnectPop';
import RegisterPagePop from './RegisterPagePop';

const LogOrRegPagePop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {


    }, [])

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("LogOrRegPage")
            setPageDetails(pg);
        }
        getPageDetalis();
    }, [])

    const goLogin = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={"משתמש רשום"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                theInsideComp={
                    <ConnectPop
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); }}
                    />
                } />)


    }
    const goRegister = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={"הרשמה"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                theInsideComp={
                    <RegisterPagePop
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); }}
                    />
                } />)
    }

    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            {pageDetails && <>
                <div className={pageStylePops.topPlaceWrap}>
                    <div className={pageStylePops.TopImg}>
                        <img src={`${ConnUrls.servMediasUrl}${!mobiOrNot ? pageDetails.PageTopImage : pageDetails.PageTopImageMobi}`}
                            className={pageStylePops.TopImg} alt={pageDetails.pageName || "התחברות או הרשמה"} />
                        <div className={pageStylePops.halfCircle}></div>
                    </div>
                </div>
                <div className={pageStylePops.contentPlaceWrap}>
                    <div className={pageStylePops.mainTextHead}>
                        {
                            props.heads.map((txt, index) => {
                                return (

                                    <span key={index} className={`${index % 2 !== 0 ? pageStylePops.gold : pageStylePops.blue} bold`}>{txt}
                                        <br />
                                    </span>
                                )
                            })}
                    </div>
                    <br />
                    <br />
                    <div className={`${pageStylePops.loginPageBtns}  inColorWhite inBackGold pointing`} onClick={() => goLogin()}>
                        <div>משתמש רשום</div>
                    </div>
                    <div className={`${pageStylePops.loginPageBtns} inColorWhite inBackBlue pointing`} onClick={() => goRegister()}>
                        <div>משתמש חדש</div>
                    </div>
                </div>
            </>
            }
            {thePopUp}
        </div >


    );
}

export default LogOrRegPagePop;
